import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-common",
  "use": "icon-common-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-common\"><path d=\"M805.7 451.8h-55.3c-68.6-0.1-146.7-0.3-146.7-0.3l88.5-322.7v-10.4c0-5.2-5.2-10.4-10.4-15.6-10.4-10.4-26-10.4-36.4 0L130.1 540c-5.2 5.2-4.2 19.6-4.2 19.6s-1 6.4 4.2 11.6c5.2 5.2 10.4 5.2 20.8 5.2h270.7l-88.5 317.5v5.2c-5.2 10.4 0 15.6 5.2 20.8 5.2 5.2 10.4 5.2 20.8 5.2 5.2 0 15.6 0 20.8-5.2l515.3-437.3c5.2-5.2 6.2-10.6 6.2-15.9s-5.4-10.3-9-12.1c-3.5-1.8-7-2.1-38.3-2.1\" fill=\"#d81e06\" p-id=\"4733\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/common.svg
// module id = TZay
// module chunks = 132